import { Alert, AlertTitle } from '@mui/material';
import type { V2InfoBlockElement } from '../../../types/V2Types';
import type { V2ElementRendererProps } from './elementProps';

/**
 * Display-only element. Has no value, no errors. Rendered as a non-dismissable
 * info alert so it visually distinguishes from input elements above/below.
 */
export function InfoBlockElement({ element }: V2ElementRendererProps<V2InfoBlockElement>) {
	return (
		<Alert
			severity="info"
			icon={false}
			data-cy={`hrr-element-${element.elementId}`}
			data-element-type="infoBlock"
			sx={{ '& .MuiAlert-message': { width: '100%' } }}>
			{element.label ? <AlertTitle>{element.label}</AlertTitle> : null}
			{element.body}
		</Alert>
	);
}
